<header
  [ngClass]="{
    'bg-black text-white ': isAuthRoute,
    'bg-gray-100 text-gray-900 ': !isAuthRoute,
  }"
  class="grid grid-cols-3 lg:grid-cols-6 items-center px-6 py-4"
>
  <!-- 'shadow-lg bg-gray-600 backdrop-blur-sm': scrolled -->

  <!-- Logo -->
  <div class="col-span-1">
    <div style="width: 60px">
      <img
        class="w-full"
        [routerLink]="['/']"
        [src]="
          isAuthRoute
            ? '/images/logo/art-stgo-logo-white.png'
            : '/images/logo/art-stgo-logo-black.png'
        "
        alt="ART STGO"
      />
    </div>
  </div>

  <!--
    El menú horizontal aparece recién en lg (1024px), no en md (768px): con seis
    ítems no cabe junto al logo y los accesos, y a 768px —el ancho exacto de un
    iPad vertical— desbordaba la página 40px, provocando scroll horizontal en
    todo el sitio. Entre 768 y 1024 se muestra el menú hamburguesa (ABC-379).
  -->
  <!-- Navegación (oculta en mobile y tablet) -->
  <nav
    class="lg:flex items-center space-x-4 hidden mx-auto col-span-1 lg:col-span-4"
  >
    @for (item of navItems; track $index) {
      <a
        [routerLink]="item.path"
        routerLinkActive="rounded-full"
        [routerLinkActiveOptions]="{ exact: item.exact || false }"
        class="px-4 py-2 transition-colors hover:rounded-full"
        [ngClass]="{
          'bg-primary text-neutral-900':
            isAuthRoute && router.isActive(item.path, item.exact || false),
          'bg-primary text-black':
            !isAuthRoute && router.isActive(item.path, item.exact || false),
          'hover:bg-primary-300 hover:text-black':
            isAuthRoute && !router.isActive(item.path, item.exact || false),
          'hover:bg-gray-200':
            !isAuthRoute && !router.isActive(item.path, item.exact || false),
          'text-white':
            isAuthRoute && !router.isActive(item.path, item.exact || false),
          'text-gray-900':
            !isAuthRoute && !router.isActive(item.path, item.exact || false),
        }"
      >
        {{ item.label }}
      </a>
    }
  </nav>

  <div class="col-span-2 lg:col-span-1 flex justify-end items-center space-x-4">
    @if (!user) {
      @if (isAuthRoute) {
        <button
          [routerLink]="[action.moviment]"
          class="px-4 py-2 transition-colors bg-primary-300 text-neutral-900 hover:bg-primary-400"
        >
          {{ action.text }}
        </button>
      } @else {
        <button
          type="button"
          (click)="openAccessModal()"
          class="px-4 py-2 transition-colors bg-black text-white cursor-pointer"
        >
          Acceder
        </button>
      }
    } @else {
      @if (!router.isActive("/favorites", false || false)) {
        <mat-icon [routerLink]="['/favorites']" class="cursor-pointer"
          >favorite_border</mat-icon
        >
      } @else {
        <mat-icon
          [routerLink]="['/favorites']"
          class="cursor-pointer !text-primary"
          >favorite</mat-icon
        >
      }
      <mat-icon (click)="openNotifications()" class="cursor-pointer"
        >notifications_none</mat-icon
      >

      <button
        (click)="openProfileModal()"
        class="hidden lg:flex w-8 h-8 rounded-full overflow-hidden border-2 border-gray-300 hover:border-gray-500 transition"
      >
        @if (user?.firebase?.picture) {
          <img
            [src]="user.firebase.picture"
            alt="Avatar"
            class="w-full h-full object-cover"
          />
        } @else {
          <div class="w-full h-full bg-gray-400"></div>
        }
      </button>
    }

    <button
      type="button"
      aria-label="Abrir menú de navegación"
      aria-haspopup="dialog"
      class="p-2 rounded transition-colors block lg:hidden"
      (click)="toggleMobileMenu()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    </button>
  </div>
</header>
